const HTTP_URL_SCHEME_REGEX = /^https?:\/\//i;
const IPV4_REGEX = /^(\d{1,3}\.){3}\d{1,3}$/;
const DOMAIN_LABEL_REGEX = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/;
const DOMAIN_TLD_REGEX = /^[a-z]{2,24}$/;

const isValidIpv4 = (hostname: string): boolean => {
  if (!IPV4_REGEX.test(hostname)) return false;
  return hostname.split('.').every((part) => Number(part) <= 255);
};

const isValidDomain = (hostname: string): boolean => {
  const parts = hostname.split('.');
  if (parts.length < 2 || parts.some((part) => part === '')) return false;
  if (parts.some((part) => part.startsWith('xn--'))) return false;
  if (!parts.every((part) => DOMAIN_LABEL_REGEX.test(part))) return false;
  return DOMAIN_TLD_REGEX.test(parts[parts.length - 1]);
};

export const isHostInDomains = (hostname: string, domains: string[]): boolean => {
  const normalized = hostname.toLowerCase();
  return domains.some((domain) =>
    normalized === domain || normalized.endsWith(`.${domain}`),
  );
};

export const parseHttpUrl = (value: string): URL | null => {
  const trimmed = value.trim();
  if (!trimmed || /\s/.test(trimmed)) return null;

  try {
    const url = new URL(
      HTTP_URL_SCHEME_REGEX.test(trimmed) ? trimmed : `https://${trimmed}`,
    );
    const hostname = url.hostname.toLowerCase();

    if (!['http:', 'https:'].includes(url.protocol)) return null;
    if (url.username || url.password) return null;
    if (!isValidDomain(hostname) && !isValidIpv4(hostname)) return null;

    return url;
  } catch {
    return null;
  }
};

export const isValidHttpUrl = (value: string): boolean =>
  value.trim() === '' || parseHttpUrl(value) !== null;
